import { breakpointValues } from '@finn/design-system/tokens/sizes';
import { getCloudinaryImgUrl } from '@finn/ui-utils';

type Props = {
  src: string;
  altText?: string;
};

export const ReferralPromoImage = ({ src, altText = '' }: Props) => {
  const lgImage = getCloudinaryImgUrl(src, {
    w: 625,
    dpr: 2,
  });
  const mdImage = getCloudinaryImgUrl(src, {
    w: 372,
    dpr: 2,
  });
  const smImage = getCloudinaryImgUrl(src, {
    w: 375,
    dpr: 2,
  });

  return (
    <picture className="flex h-full justify-center">
      <source
        media={`(min-width: ${breakpointValues.md}px)`}
        data-srcset={lgImage}
      />
      <source
        media={`(min-width: ${breakpointValues.sm}px)`}
        data-srcset={mdImage}
      />
      <img
        data-src={smImage}
        alt={altText}
        className={`lazyload stop-sticky-conversion w-full object-cover`}
      />
    </picture>
  );
};
